import React from 'react';
import { Box, Text, Stack, Button, Icon, List, ListItem, ListIcon } from '@chakra-ui/react';
import { CheckCircle } from 'lucide-react';

const UnlockFreeTrial = ({ onClick }) => (
    <Box
        bg="white"
        borderRadius="lg"
        boxShadow="sm"
        p={{ base: 2, sm: 5, md: 7 }}
        maxW={{ base: '95vw', sm: '340px' }}
        w="100%"
        mx={{ base: 'auto', sm: 'auto' }}
        border="1px solid #E5E7EB"
        mt={{ base: 3, md: 0 }}
    >
        <Text fontSize={{ base: 'xs', sm: 'sm' }} color="green.600" fontWeight="bold" mb={1} letterSpacing={0.5}>
            FINAL STEP
        </Text>
        <Text fontSize={{ base: 'xl', sm: '2xl' }} fontWeight="extrabold" color="gray.800" mb={2} lineHeight="1.2">
            Unlock Your Free Trial
        </Text>
        <Text color="gray.700" fontSize={{ base: 'sm', sm: 'md' }} mb={3}>
            Try Dialzara with no risk. Your first 60 minutes are on us. Cancel anytime without penalty.
        </Text>
        <List spacing={1} mb={4}>
            <ListItem display="flex" alignItems="center">
                <ListIcon as={CheckCircle} color="green.500" boxSize={5} mr={1} />
                <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray.800">60 free talk minutes</Text>
            </ListItem>
            <ListItem display="flex" alignItems="center">
                <ListIcon as={CheckCircle} color="green.500" boxSize={5} mr={1} />
                <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray.800">Custom local or toll-free number</Text>
            </ListItem>
            <ListItem display="flex" alignItems="center">
                <ListIcon as={CheckCircle} color="green.500" boxSize={5} mr={1} />
                <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray.800">Full access for 7 days</Text>
            </ListItem>
        </List>
        <Button
            w="100%"
            size={{ base: 'md', sm: 'lg' }}
            fontWeight="bold"
            fontSize={{ base: 'sm', sm: 'md' }}
            bg="#34A853"
            color="white"
            borderRadius="md"
            py={{ base: 4, sm: 6 }}
            _hover={{ bg: '#24913c' }}
            onClick={onClick}
            mb={1}
        >
            Start Free Trial
        </Button>
        <Text fontSize={{ base: 'xs', sm: 'xs' }} color="gray.400" mt={2} textAlign="center">
            Instant activation. Cancel anytime.
        </Text>
    </Box>
);

export default UnlockFreeTrial;
